import React, { useContext } from 'react';
import Styled from 'styled';
import classnames from 'classnames';

import { InterscrollerPlaceholder, InterscrollerContext } from 'lib/google/dfp/ad-units/interscroller';

import { ProductsESQuery } from '../products.graphql';
import ProductEs from '../product-es/product-es';

import defaultStyles from './products-grid.scss';

type Edges = NonNullable<ProductsESQuery['products']>['edges'];

interface Props {
    styles: typeof defaultStyles;
    edges?: Edges;
    interscroller?: boolean;
}

const ProductsGrid: React.FC<Props> = props => {
    const { styles, edges, interscroller = false } = props;

    const { isActive } = useContext(InterscrollerContext);

    return (
        <ul className={styles.tilesWrapper}>
            {edges
                ? edges.map((edge, index) =>
                      edge && edge.node ? (
                          <React.Fragment key={`${index}-Fragment`}>
                              <li key={index} className={styles.tileWrapper}>
                                  <ProductEs {...edge.node} />
                              </li>
                              {index === 3 ? (
                                  <li
                                      key={`${index}-interscroller`}
                                      className={classnames(styles.tileWrapper, {
                                          [styles.tileEmpty]: isActive,
                                      })}
                                  >
                                      {interscroller ? <InterscrollerPlaceholder /> : null}
                                  </li>
                              ) : null}
                          </React.Fragment>
                      ) : null
                  )
                : null}
        </ul>
    );
};

export default Styled(defaultStyles)(ProductsGrid);
